// Module
var code = "<div class=\"type-preview\"> <div class=\"type-preview-select\"> <label>Type:</label> <div class=\"type-name\">Not selected</div> </div> <a class=\"toggleDetails btn-flat waves-effect waves-blue\" style=\"display:none\">View</a> </div> <div class=\"fields-list-container\" style=\"display:none\"></div> ";
// Exports
export default code;